const devSettings = {
    openTokApi: "46414262",
    signalRServerUrl: "https://localhost:44332/hub/photo",
    googleMapApi: "AIzaSyBVLxuvw-zjUUU-V_yZT1On3oBuER32qsk",
    url: "https://localhost:44332/",
}

const liveSettings = {
    openTokApi: "46414262",
    signalRServerUrl: "https://admin.remotepros.com.au/hub/photo",
    url: "https://admin.remotepros.com.au",
    googleMapApi: "AIzaSyBVLxuvw-zjUUU-V_yZT1On3oBuER32qsk",
}

const settings = process.env.NODE_ENV !== "development" ?  liveSettings : devSettings;


export default settings;
